export default {

    methods: {
        format(dateInput) {
            const date = new Date(dateInput);

            // Format to "YYYY MM DD"
            return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        },
    },
};